<template>
  <div class="table-wrapper" v-if="data.length">
    <div class="table-header">
      <slot name="cc-table-header"></slot>
      <div v-if="$md.mobile() !== null">
        <div class="control-wrapper-mobile">
          <!--<div class="additional-filter-wrapper">
            <i class="additional-filter"></i>
          </div>-->
          <div>
            <CCCalendar :actionEvent="this.setDateRanges" :namespace="namespace"></CCCalendar>
          </div>
          <div class="columns-customization-mobile">
            <CCTableCustomizationColumns :columns="columns" :defaultColumns="defaultColumns" :namespace="namespace"></CCTableCustomizationColumns>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="control-wrapper">
          <div class="search-wrapper" v-if="showSearchBar">
            <input type="text" name="search" v-model="search" v-on:keyup.enter="useSearch" placeholder="Search">
            <div @click="useSearch">
              <i class="search-icon"></i>
            </div>
          </div>
          <div class="columns-customization-wrapper">
            <CCTableCustomizationColumns :columns="columns" :defaultColumns="defaultColumns" :namespace="namespace"></CCTableCustomizationColumns>
          </div>
        </div>
      </div>
    </div>

    <div class="table-data-wrapper" v-bind:class="{'fixedColumnWidth': isAnyFixedColumnsExist}">

      <!-- FIXED TABLE START -->

      <div class="fixedColumnsTable" v-if="isAnyFixedColumnsExist">
        <table class="table">

          <template v-if="customTableTheadTemplate">
            <component v-bind:is="customTableTheadTemplate"
                       :data="data"
                       :columns="columns"
                       :tableContainerId="tableContainerId"
                       :namespace="namespace"></component>
            </template>
          <template v-else>
            <TableHead :data="data" :columns="getOnlyFixedColumn(columns)" :namespace="namespace" :tableContainerId="tableContainerId"
                       :customTableHeadTemplate="customTableHeadTemplate"
                       :customTableHeadDatesComparisonTemplate="customTableHeadDatesComparisonTemplate"
                       :customTableHeadSellingPartnersTemplate="customTableHeadSellingPartnersTemplate"
                       fixed>

              <template v-if="customTableHeadTemplate" slot="customHeaderDataFixed" slot-scope="customData">
                <component v-bind:is="customTableHeadTemplate"
                           :columnData="customData"></component>
              </template>

              <template v-if="customTableHeadDatesComparisonTemplate" slot="customHeaderDatesComparisonDataFixed" slot-scope="customData">
                <component v-bind:is="customTableHeadDatesComparisonTemplate"
                           :columnData="customData"></component>
              </template>

              <template v-if="customTableHeadSellingPartnersTemplate" slot="customHeaderSellingPartnersDataFixed" slot-scope="customData">
                <component v-bind:is="customTableHeadSellingPartnersTemplate"
                           :columnData="customData"></component>
              </template>

            </TableHead>
          </template>

          <template v-if="data.length">

            <template v-if="customTableTbodyTemplate">
              <component v-bind:is="customTableTbodyTemplate"
                         :data="data"
                         :columns="columns"
                         :defaultColumns="defaultColumns"
                         :namespace="namespace"
                         :reportSummaryData="reportSummaryData"
                         fixed></component>
            </template>
            <template v-else>
              <TableBody :data="data" :columns="getOnlyFixedColumn(columns)" :namespace="namespace"
                         :dropDownMenuUrls="dropDownMenuUrls" :fieldNameDropDown="fieldNameDropDown"
                         :editableFieldsList="editableFieldsList"
                         :customTableTbodyTemplate="customTableTbodyTemplate"
                         :defaultColumns="defaultColumns" :customTableBodyTemplate="customTableBodyTemplate"
                         fixed>

                <template v-if="customTableBodyTemplate" slot="customBodyDataFixed" slot-scope="customData">
                  <component v-bind:is="customTableBodyTemplate"
                             :columnData="customData"></component>
                </template>

                <template v-if="customTableBodyDynamicFieldTemplate" slot="customBodyDynamicFieldDataFixed" slot-scope="customData">
                  <component v-bind:is="customTableBodyDynamicFieldTemplate"
                             :columnData="customData"></component>
                </template>

              </TableBody>
            </template>

          </template>
        </table>
      </div>

      <!-- FIXED TABLE END -->

      <div :id="tableWrapperContainerId" ref="tableWrapperContainerId" class="table-wrapper-container" v-bind:class="{'fixed-active': isAnyFixedColumnsExist}">
        <div class="table-main">
          <table class="table table-container" :ref="tableContainerId">

            <template v-if="customTableTheadTemplate">
              <component v-bind:is="customTableTheadTemplate"
                         :data="data"
                         :columns="columns"
                         :tableContainerId="tableContainerId"
                         :namespace="namespace"></component>
            </template>
            <template v-else>
              <TableHead :data="data" :columns="columns" :namespace="namespace"
                         :customTableHeadTemplate="customTableHeadTemplate"
                         :customTableHeadDatesComparisonTemplate="customTableHeadDatesComparisonTemplate"
                         :customTableHeadSellingPartnersTemplate="customTableHeadSellingPartnersTemplate"
                         :tableContainerId="tableContainerId">

                <template v-if="customTableHeadTemplate" slot="customHeaderData" slot-scope="customData">
                  <component v-bind:is="customTableHeadTemplate"
                             :columnData="customData"></component>
                </template>

                <template v-if="customTableHeadDatesComparisonTemplate" slot="customHeaderDatesComparisonData" slot-scope="customData">
                  <component v-bind:is="customTableHeadDatesComparisonTemplate"
                             :columnData="customData"></component>
                </template>

                <template v-if="customTableHeadSellingPartnersTemplate" slot="customHeaderSellingPartnersData" slot-scope="customData">
                  <component v-bind:is="customTableHeadSellingPartnersTemplate"
                             :columnData="customData"></component>
                </template>

              </TableHead>
            </template>

            <template v-if="data.length">
              <template v-if="customTableTbodyTemplate">
                <component v-bind:is="customTableTbodyTemplate"
                           :data="data"
                           :columns="columns"
                           :defaultColumns="defaultColumns"
                           :namespace="namespace"
                           :reportSummaryData="reportSummaryData"
                ></component>
              </template>
              <template v-else>
                <TableBody :data="data" :columns="columns" :namespace="namespace"
                           :defaultColumns="defaultColumns"
                           :dropDownMenuUrls="dropDownMenuUrls"
                           :fieldNameDropDown="fieldNameDropDown"
                           :editableFieldsList="editableFieldsList"
                           :customTableTbodyTemplate="customTableTbodyTemplate"
                           :customTableBodyTemplate="customTableBodyTemplate"
                           :customTableBodyDynamicFieldTemplate="customTableBodyDynamicFieldTemplate">

                  <template v-if="customTableTbodyTemplate" slot="customTableTbody" slot-scope="customData">
                    <component v-bind:is="customTableTbodyTemplate"
                               :data="customData.data"
                               :columns="customData.columns"
                               :namespace="customData.namespace"
                               :reportSummaryData="reportSummaryData"
                    ></component>
                  </template>

                  <template v-if="customTableBodyTemplate" slot="customBodyData" slot-scope="customData">
                    <component v-bind:is="customTableBodyTemplate"
                               :columnData="customData"></component>
                  </template>

                  <template v-if="customTableBodyDynamicFieldTemplate" slot="customBodyDynamicFieldData" slot-scope="customData">
                    <component v-bind:is="customTableBodyDynamicFieldTemplate"
                               :columnData="customData"></component>
                  </template>

                </TableBody>
              </template>
            </template>
          </table>

          <template v-if="data.length == 0">
            <div style="margin-top: 20px;margin-bottom: 20px;">There are no results</div>
          </template>
        </div>
      </div>
    </div>

    <div class="table-bottom-wrapper">
      <div class="action-button-wrapper">
        <button @click="exportReportAsCSV()" v-if="showExportButton">Export as CSV</button>
      </div>

      <CCTablePagination :data="data" :paginationOptions="paginationOptions" :namespace="namespace"></CCTablePagination>

    </div>
  </div>
</template>

<script>

  import '@/style/reports/base_table_style.scss';

  import tableCommonMixin from '@/components/reports/mixins/tableCommonMixin';

  import TableHead from '@/components/reports/common/table/TableHead';
  import TableBody from '@/components/reports/common/table/TableBody';

  import CCTableCustomizationColumns from '@/components/reports/common/table/CCTableCustomizationColumns';
  import CCTablePagination from '@/components/reports/common/table/CCTablePagination';
  import CCCalendar from '@/components/common/CCCalendar';

  import fixTableMixin from '@/components/reports/mixins/fixTableMixin';
  import sellingPartnerMixin from '@/components/reports/mixins/sellingPartnerMixin';
  import datesComparisonTableMixin from '@/components/reports/mixins/datesComparisonTableMixin';
  import filterMixin from '@/components/mixins/filterMixin';

  export default {
    name: "cc-table",
    components: {
      TableHead,
      TableBody,
      CCTableCustomizationColumns,
      CCTablePagination,
      CCCalendar
    },
    mixins: [
      tableCommonMixin,
      fixTableMixin,
      sellingPartnerMixin,
      datesComparisonTableMixin,
      filterMixin
    ],
    props: {
      data: {
        type: Array,
        required: true
      },
      reportSummaryData: {
        type: [Array, Object],
        required: false
      },
      columns: {
        type: Array,
        required: true
      },
      defaultColumns: {
        type: Array,
        requred: true
      },
      paginationOptions: {
        type: Array,
        required: true
      },
      namespace: {
        type: String,
        required: true
      },
      dropDownMenuUrls: {
        type: Array,
        required: false,
      },
      fieldNameDropDown: {
        type: Array,
        required: false
      },
      editableFieldsList: {
        type: Array,
        required: false
      },
      showSearchBar: {
        type: Boolean,
        required: false
      },
      showExportButton: {
        type: Boolean,
        required: false
      },
      customTableTheadTemplate: {
        type: Object,
        required: false,
        default: null
      },
      customTableTbodyTemplate: {
        type: Object,
        required: false,
        default: null
      },
      customTableHeadTemplate: {
        type: Object,
        required: false,
        default: null
      },
      customTableHeadDatesComparisonTemplate: {
        type: Object,
        required: false,
        default: null
      },
      customTableHeadSellingPartnersTemplate: {
        type: Object,
        required: false,
        default: null
      },
      customTableBodyTemplate: {
        type: Object,
        required: false,
        default: null
      },
      customTableBodyDynamicFieldTemplate: {
        type: Object,
        required: false,
        default: null
      }
    },
    data (){
      return {
        tableWrapperContainerId: this._uid + '_wrapper_container_id',
        tableContainerId: this._uid + '_table_container_id',
        search: null,
        scrolledElementPosition: {left: null, top: null, width: null, clientHeight: null},
        isLoading: true,
        headerColumnsSizesList: []
      }
    },
    computed: {
    },
    methods: {
      // exportReportAsCSV: function(){
      //   let that = this;
      //   let filters = {
      //     reportFilters: null,
      //     sorting: {
      //       sortColumn: null,
      //       sortDirection: null
      //     },
      //     format: 'CSV'
      //   };
      //
      //   filters.reportFilters = this.$store.getters[this.namespace + '/getReportFilters'];
      //   filters.sorting.sortColumn = this.$store.getters[this.namespace + '/getSortColumn'];
      //   filters.sorting.sortDirection = this.$store.getters[this.namespace + '/getSortDirection'];
      //
      //   if (filters.reportFilters.sites.length > 0 && filters.reportFilters.sources.length > 0)
      //   {
      //     this.$store.dispatch(this.namespace + '/startLoading');
      //
      //     let objects = null;
      //     objects = this.$store.dispatch(this.namespace + '/getReportDataFromAPI', filters);
      //
      //     objects.then(function (result) {
      //       if (result !== undefined)
      //       {
      //         if (result.size > 0)
      //         {
      //           var a = window.document.createElement("a");
      //           a.href = window.URL.createObjectURL(result, {type: "text/plain"});
      //           a.download = that.namespace + ".csv";
      //           document.body.appendChild(a);
      //           a.click();
      //           document.body.removeChild(a);
      //         }
      //       }
      //
      //       that.$store.dispatch(that.namespace + '/finishLoading');
      //     });
      //   }
      // },
      useSearch: function(){
        if (this.search == '')
        {
          this.search = null;
        }

        this.$store.dispatch(this.namespace + '/setReportSearch', this.search);
        this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
        this.$store.dispatch(this.namespace + '/startLoading');
      },
      setDateRanges(startDate, endDate, startDateB, endDateB, excludedDates, excludedDatesB) {
        this.$store.dispatch(this.namespace + '/setDateRanges', {startDate: startDate, endDate: endDate, startDateB: startDateB, endDateB: endDateB, excludedDates: excludedDates, excludedDatesB: excludedDatesB}, {root: true});
        this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
        this.$store.dispatch(this.namespace + '/startLoading');
      },
      getOnlyFixedColumn(columns){
        let that = this;

        let fixedColumns = columns.reduce(function(acc, item){
          if (that.fixedColumns.includes(item.field)) {
            acc.push(item);
          }
          return acc;
        }, []);

        return fixedColumns;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .control-wrapper {
    float: right;
    margin-right: 25px;

    .search-wrapper {
      float: left;
      margin-right: 15px;
      border: 1px solid $border-color;
      border-radius: $border-radius;

      background-image: -ms-linear-gradient(top, $block-gradient-background-top 0%, $block-gradient-background-middle 50%, $block-gradient-background-bottom 100%);
      background-image: -moz-linear-gradient(top, $block-gradient-background-top 0%, $block-gradient-background-middle 50%, $block-gradient-background-bottom 100%);
      background-image: -o-linear-gradient(top, $block-gradient-background-top 0%, $block-gradient-background-middle 50%, $block-gradient-background-bottom 100%);
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, $block-gradient-background-top), color-stop(50, $block-gradient-background-middle 50), color-stop(100, $block-gradient-background-bottom));
      background-image: -webkit-linear-gradient(top, $block-gradient-background-top 0%, $block-gradient-background-middle 50%, $block-gradient-background-bottom 100%);
      background-image: linear-gradient(to bottom, $block-gradient-background-top 0%, $block-gradient-background-middle 50%, $block-gradient-background-bottom 100%);

      & > input {
        font-size: 1em;
        padding: 8px 8px 9px 8px;
        background: #fff;
        border: 0;
        border-right: 1px solid $border-color;
      }

      & > input::placeholder{
        color: #c6c6c6;
      }

      & > div {
        display: inline-block;
        width: 35px;
        cursor: pointer;
      }

      .search-icon {
        width: 1.15em;
        height: 1.15em;
        display: inline-block;
        vertical-align: middle;
        background-image: url('/static/img/icon-table-search.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }

    .columns-customization-wrapper {
      float: right;
      right: 1vw;
      cursor: pointer;

      & > div {
        border: 1px solid $border-color;
        border-radius: $border-radius;
        padding: 9px;

        & > span {
          font-size: 14px;
          margin: auto 0 auto 5px;
        }
      }
    }
  }

  .table-bottom-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 15px;
    margin-bottom: 15px;

    & > .action-button-wrapper {
      text-align: left;
      margin-left: 25px;

      & > button {
        background-color: #fff;
        color: #676767;
        padding: 10px 25px;
        border: 1px solid #d7d7d7;
        border-radius: 3px;
      }
    }
  }

  .fixedColumnsTable {
    .table {
      border-right: 1px solid #d7d7d7;
    }
  }


  .table-wrapper {
    /*display: grid;*/
    border: 1px solid $border-color;
    max-width: 100%;
    width: 100%;
    border-left: none;
    border-right: none;
    border-bottom: none;
  }

  .table-wrapper-container {
    overflow-x: auto;
    margin-left: 25px;
    margin-right: 25px;
    padding-bottom: 10px;
    width: 100%;
    height: 100%;
    overflow-y: hidden;

    &.fixed-active {
      margin-left: 0;
    }

    &::-webkit-scrollbar-track
    {
      border-radius: 8px;
      background-color: #d8d8d8;
    }

    &::-webkit-scrollbar
    {
      width: 8px;
      border-radius: 8px;
      background-color: #9b9b9b;
      height: 8px;
    }

    &::-webkit-scrollbar-thumb
    {
      border-radius: 8px;
      -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,.3);
      background-color: #9b9b9b;
      height: 50%;
    }
  }

  .sticky-header-column {
    position: relative;
    z-index: 2;
    transition: 0.3s;
  }

  .sticky-body-column {
    position: relative;
    display: table-cell;
    transition: 0.3s;
  }

  .sticky-body-column:nth-last-child {
    border-right: 3px solid #cecece;
  }
  .table-wrapper {
    background-color: #fff;
    width: 100%;
    max-width: calc(100% - 64px);

    & > .table-main {
      overflow-x: auto;
      margin-left: 25px;
      margin-right: 25px;
    }
  }

  .table-wrapper .table-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 25px;
    margin-bottom: 15px;
    margin-left: 25px;

    & > div > h4 {
      font-size: 30px;
      color: $table-header-title-color;
      text-align: left;
      margin: 0 0 0 25px;
    }
  }

  .table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 10px;

    & > thead {

      &.sticky {
        position: sticky;
        will-change: transform;

        & > * {
          -webkit-transform: translateZ(0);
        }
      }

      &.stickyHeader {
        position: fixed;
        top: 0;
        transition: all .5s ease-in-out;
      }

      & > tr {
        text-align: left;

        & > th {
          padding: 5px 0 5px 5px;
          border: 1px solid $border-color;
          cursor: pointer;
          height: 40px;

          background: -moz-linear-gradient(top, #fbfbfb 5%, #ededed 100%); /* FF3.6-15 */
          background: -webkit-linear-gradient(top, #fbfbfb 5%, #ededed 100%); /* Chrome10-25,Safari5.1-6 */
          background: linear-gradient(to bottom, #fbfbfb 5%, #ededed 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fbfbfb', endColorstr='#ededed', GradientType=0); /* IE6-9 */

          & > div {
            display: flex;
            align-content: center;
            align-self: center;
            //align-items: baseline;
          }

          & > * {
            font-family: $font-stack;
            font-size: 13px;
          }

          &:hover {
            background: #e7e7e7;
          }

          & + .hidden {
            display: none;
          }

          & + .small {
            min-width: 100px;
            font-size: 12px;
            font-weight: bold;
            padding: 5px 10px 5px 10px;
            text-align: left;
          }

          &.align-right {
            vertical-align: top;
          }
        }

        & > th:first-child {
          border-left: 0;
        }

        & > th:last-child {
          border-right: 0;
        }

        &.datesRangeComparisonHeader {
          & > th {
            background: #f3f3f3;
            height: 40px;
          }
        }
      }
    }

    & > tbody > tr {
      text-align: left;

      &:hover {
        background: #f5f5f5;
      }

      & > * {
        font-size: 13px;
      }

      & > td {
        border-right: 1px solid #f3f3f3;
        padding: 5px;
      }

      & > td.hovered {
        background: #f5f5f5;

        &.alter{
          background: #eef1f4;
        }
      }

      & > td.hidden {
        display: none;
      }

      & > td:last-child {
        border: 0;
      }
    }
  }

  .fixedColumnsTable {

    background: #fff;
    margin-left: 25px;

    .table {
      & > thead {
        & > tr {
          & > th {

            &.fixed:last-child{
              border-right: 2px solid #d7d7d7;
            }

            &.small {
              font-size: 12px;
              font-weight: bold;
              padding: 5px 10px 5px 10px;
              text-align: left;
              border: 1px solid #d7d7d7;

              &:last-child {
                border-right: 2px solid #d7d7d7;
              }
            }
          }

          &.datesRangeComparisonHeader {
            height: 25px;
          }
        }
      }

      & > tbody {
        & > tr {
          & > td {
            &.fixed:last-child {
              border-right: 2px solid #cecece;
            }

            & .editable-column {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .slide-fade-enter-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-leave-active {
    transition: all .25s ease;
    opacity: 0;
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */{
    transform: translateX(10px);
    opacity: 0;
  }

  .column-dates-comparison-wrapper {
    clear: both;
    float: right;
    margin-right: 15px;

    & > i {
      display: block;
      vertical-align: middle;
      width: 1em;
      height: 1em;
      background-image: url('/static/img/icon-date-comparison-disabled.svg');
      background-repeat: no-repeat;
      background-position: left center;
      background-size: contain;

      &.active {
        background-image: url('/static/img/icon-date-comparison-enabled.svg');
      }
    }
  }

  .column-partners-data-comparison-wrapper {
    clear: both;
    float: right;
    margin-right: 15px;

    & > i {
      display: block;
      vertical-align: middle;
      width: 1em;
      height: 1em;
      background-image: url('/static/img/icon-date-comparison-disabled.svg');
      background-repeat: no-repeat;
      background-position: left center;
      background-size: contain;

      &.active {
        background-image: url('/static/img/icon-date-comparison-enabled.svg');
      }
    }
  }

  @include mobile-only{
    .control-wrapper {
      display: none;
    }
    .table-wrapper-container {
      margin-left: 0;
      margin-right: 0;
    }

    .dropdown-menu-wrapper {
      width: 100vw;
      height: 100vh;
      margin-left:0;
      top: 0;
      left: 0;
      right: 0;
    }

    .fixedColumnsTable {
      margin-left: 0;
    }

    .table-wrapper {
      max-width: 100%;
    }

    .table-wrapper .table-header {
      margin-top: 0;
      margin-bottom: 0;
      margin-left: 0;

      & > div {
        width: 100%;
      }
    }

    .table > thead {

      &.sticky {
        position: sticky;
        transition: none;

        & > * {
          -webkit-transform: translateZ(0);
          transform: translate3d(0px,0px,0px);
        }
      }
    }

    .table-bottom-wrapper {
      grid-template-columns: 1fr;

      & > .row {
        justify-content: center;
      }

    }

    .action-button-wrapper {
      display: none;
    }

    .control-wrapper-mobile {
      display: grid;
      grid-template-columns: 1fr 45px;

      & > div {
        border: 1px solid $border-color;
        border-top: 0;
        border-bottom: 0;
        padding: 5px 0 0 0;

        &.additional-filter-wrapper {

          & > i.additional-filter {
            display: inline-block;
            width: 1.5em;
            height: 1.5em;
            background-image: url('/static/img/icon-filter-mobile.svg');
            background-repeat: no-repeat;
            background-position: left center;
            background-size: contain;
          }

          & > i.mobile-columns-customization {
            width: 1.5em;
            height: 1.5em;
          }
        }


        &.columns-customization-mobile {
          padding-left: 5px;
          padding-right: 5px;
        }

        &:first-child {
          border-left: 0;
          border-right: 0;
        }

        &:last-child {
          border-right: 0;
        }

      }

    }
  }

  .table-data-wrapper {
    background-color: #fff;
    width: 100%;
    display: flex;
  }

</style>



// WEBPACK FOOTER //
// src/components/reports/common/table/CCTable.vue